module.exports = __webpack_public_path__ + "static/16-aea02a463f617fcc41c40146f29f747e.png";